<template>
  <div id="lead-unit-details">
    <div class="ld-unit-details">
      <div class="ld-row-container">
        <div class="ld-header">
          Unit Details and Performance
        </div>
        <div class="ld-mini-header">
          Warranty Expires on 8/25/2025
        </div>
      </div>
      <div class="ld-row-container-2">
        <div class="ld-sub">
          <div class="ld-label">
            MFR.
          </div>
          <div class="ld-text">
            {{ hvac.manufacturer || '--' }}
          </div>
        </div>
        <div class="ld-sub">
          <div class="ld-label">
            Speed
          </div>
          <div class="ld-text">
            {{ hvac.speed || '--' }}
          </div>
        </div>
        <div class="ld-sub">
          <div class="ld-label">
            Refrigerant
          </div>
          <div class="ld-text">
            {{ hvac.refrigerant || '--' }}
          </div>
        </div>
        <div class="ld-sub">
          <div class="ld-label">
            Model
          </div>
          <div class="ld-text">
            {{ hvac.model || '--' }}
          </div>
        </div>
      </div>
      <div class="ld-row-container-2">
        <div class="ld-sub">
          <div class="ld-label">
            MFR. Date
          </div>
          <div class="ld-text">
            {{ hvac.mfgDate || '--' }}
          </div>
        </div>
        <div class="ld-sub">
          <div class="ld-label">
            Type
          </div>
          <div class="ld-text">
            {{ hvac.type || '--' }}
          </div>
        </div>
        <div class="ld-sub">
          <div class="ld-label">
            Unit Age
          </div>
          <div class="ld-text">
            {{ hvac.age || '--' }}
          </div>
        </div>
        <div class="ld-sub">
          <div class="ld-label">
            Serial
          </div>
          <div class="ld-text">
            {{ hvac.serialNumber || '--' }}
          </div>
        </div>
      </div>
    </div>
    <RuntimeLineGraph
      v-if="alert.type.includes('Runtime')"
    />
    <SensorGraph v-else />
  </div>
</template>

<script>
import RuntimeLineGraph from '@shared/components/leadDetailPdf/performance/RuntimeLineGraph.vue';
import SensorGraph from '@shared/components/leadDetailPdf/performance/SensorGraph.vue';
import leadDetailMixin from '@shared/mixins/leadDetailMixin';

export default {
  name: 'UnitDetails',
  components: {
    RuntimeLineGraph,
    SensorGraph,
  },
  mixins: [leadDetailMixin],
};
</script>

<style lang="scss">

#lead-unit-details {
  display: grid;
  align-content: space-between;
  padding: 1rem 2rem;
  width: 100%;
  background: linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(243,244,246,1) 30%);
  .ld-unit-details {
    .ld-header {
      font-weight: 700;
      color: $N100;
      font-size: 12pt;
    }
    .ld-label {
      font-weight: 500;
      font-size: 8pt;
    }
    .ld-text {
      font-size: 8pt;
    }
    .ld-mini-header {
      font-weight: 700;
      color: $N100;
      font-size: 8pt;
    }
    .ld-row-container-2 {
      display: grid;
      grid-template-columns: 24% 24% 24% 20%;
      gap: 1rem;
      grid-auto-flow: column;
      justify-content: space-between;
      .ld-sub {
        display: grid;
        grid-auto-flow: column;
        justify-content: space-between;
        font-size: 0.75rem;
        width: 100%;
        &:not(:nth-child(4)):not(:nth-child(8)) {
          border-right: 1px solid $N40;
          padding-right: 22px;
        }
      }
    }
    .ld-row-container {
      display: grid;
      grid-auto-flow: column;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;
    }
  }
}

</style>
